import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="Страница не найдена"
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Перейти на главную страницу
        </Button>
      }
    />
  );
};

export default NotFound;
